"use strict";
import simpleModal from "./simpleModal";

export class AuthModal {
    cid;
    gid;
    constructor() {
        this.cid = typeof window.cid !== 'undefined' ? window.cid : 0;
        this.gid = typeof window.gid !== 'undefined' ? window.gid : 0
    }

    authenticate(action = '', $options = {}) {
        const { openerObj = null, template = '', afterLoginArgs = {}, templateArgs = {} } = $options;
        // console.log('authenticate with action:', action);
        globalParams.loginContext = {cid: this.cid, gid: this.gid}
        globalParams.afterLoginAction = action
        globalParams.afterLoginArgs = afterLoginArgs   
        globalParams.opener = openerObj
        globalParams.template = template
        globalParams.templateArgs = templateArgs
        modal = initModal()
        resetLoadHistory()
        return loadLoginForm()
    }
}

let globalParams = {
    lastSendCodeRequest: null,
    afterLoginAction: '',
    afterLoginArgs: {},
    opener: null,
    loadHistory: [],
    currentForm: null,
    template: '',
    templateArgs: {},
    loginContext: {},
}
let instance = new AuthModal()
let modal = null

// Advanced exporting routine.
export default async function (action = '', $options = {}) 
{
    // reset auth process
    instance = new AuthModal()
    return instance.authenticate(action, $options)
}


const resetLoadHistory = () => {
    globalParams.loadHistory = []
    return true
}

const agreeTerms = function () {
    const $checkbox = $(modal.$.find('input#Checkbox__Agree_Terms'));
    if ($checkbox.length > 0 && $checkbox.is(':not(:checked)')) {
        const $group = $checkbox.closest('.form-group')
        const $error = $group.find('.help-block-error')
        $group.addClass('has-error');
        $error.text($checkbox.data('error'))
        $checkbox.focus();
        $checkbox.attr('aria-describedby', 'Checkbox__Agree_Terms_Error');
        $checkbox.attr('aria-invalid', true);
        return false;
    }
    return true;
}

const addAfterLoginActionParam = function () {
    window.localStorage.setItem('afterLoginAct', globalParams.afterLoginAction);
    window.localStorage.setItem('afterLoginArgs', JSON.stringify(globalParams.afterLoginArgs));
    // console.log('set afterLoginAct', window.localStorage.getItem('afterLoginAct'));
    // console.log('set afterLoginArgs', window.localStorage.getItem('afterLoginArgs'));
};

const resetAfterLoginParams = function () {
    // console.log('reset afterLoginAct', window.localStorage.getItem('afterLoginAct'));
    // console.log('reset afterLoginArgs', window.localStorage.getItem('afterLoginArgs'));
    window.localStorage.removeItem('afterLoginAct');
    window.localStorage.removeItem('afterLoginArgs');
};

const formToObject = function (form) {
    const formData = new FormData(form)
    let result = {}
    for (let key of formData.keys()) {
        result[key] = formData.get(key)
    }
    return result
}

const addFormSummary = function (form, errors) {
    form.find('.error-summary').html('')
    if (errors.length) {
        const errorsContainer = $('<ul></ul>')
        form.find('.error-summary').append(errorsContainer)
        errors.forEach(value => errorsContainer.append('<li>' + value + '</li>'))
        return true
    }
    return false
}

const _loadModalContent = async (options, focus = null) => {

    options.data.template = globalParams.template
    options.data.templateArgs = globalParams.templateArgs
    await modal.loadContent(options)

    if (window.configCloseAsBack) {
        window.configCloseAsBack = undefined
        modal.$.find('[data-action=close]').attr('data-action', 'back')
    }
    // if (window.group) {
    //     modal.$.find('.window-header-title').append('<div class="group-title">' + window.group.name + '</div>')
    // }
    let i = 1
    modal.$.find(':focusable').each(function () {
        $(this).attr('data-focus', i++)
    })
    if (focus) {
        setTimeout(() => {
            $(`[data-focus="${focus}"]`).focus()
            console.debug('focus', document.activeElement)
        })

    }
}

const pushHistory = () => {
    if (globalParams.currentForm) {
        globalParams.loadHistory.push([globalParams.currentForm, document.activeElement.dataset.focus])
    }
}

const loadForm = async options => {
    pushHistory()
    globalParams.currentForm = options
    return _loadModalContent(globalParams.currentForm)
}

const loadBack = () => {
    let focus
    [globalParams.currentForm, focus] = globalParams.loadHistory.pop()
    _loadModalContent(globalParams.currentForm, focus)
    return false
}

const loadLoginForm = () => loadForm({url: '/site/auth/login/form', data: globalParams.loginContext, opener: globalParams.opener})
const loadForgotPasswordForm = () => loadForm({url: '/site/auth/forgot-password', data: globalParams.loginContext})
const loadCreateForm = () => loadForm({url: '/site/auth/create', data: globalParams.loginContext})
const loadEmailForm = () => loadForm({url: '/site/auth/login/email', data: globalParams.loginContext})
const loadSmsForm = () => loadForm({url: '/site/auth/login/sms', data: globalParams.loginContext})
const loadIdForm = () => loadForm({url: '/site/auth/login/id', data: globalParams.loginContext})


window.loadTermsContent = () => loadForm({url: '/site/auth/login/terms', data: globalParams.loginContext})
window.loadPrivacyContent = () => loadForm({url: '/site/auth/login/privacy', data: globalParams.loginContext})

const initModal = () =>
{
    const modal = new simpleModal({id: 'AuthModal', small: true, bodyClass: ' '})

    modal.$.on('click', '.forgot-password', loadForgotPasswordForm)
    modal.$.on('click', '.signup-button', loadCreateForm)
    modal.$.on('click', '.back-button', loadBack)
    modal.$.on('click', '[data-action=close]', resetLoadHistory)
    modal.$.on('click', '[data-action=back]', function () {
        $(this).attr('data-action', 'close')
        loadBack()
        return false
    })
    modal.$.on('click', '.signin-button', () => resetLoadHistory() && loadLoginForm())
    modal.$.on('click', 'a[data-id="email"]', () => agreeTerms() && loadEmailForm())
    modal.$.on('click', 'a[data-id="sms"]', () => agreeTerms() && loadSmsForm())
    modal.$.on('click', 'a[data-login-method="id"]', () => agreeTerms() && loadIdForm())
    modal.$.on('click', '.btn-restart-login', () => loadLoginForm().then(() => resetLoadHistory()))
    modal.$.on('closed.cc.modal', () => resetAfterLoginParams())

    modal.$.on('submit', 'form#SendCode', function (e) {
        e.preventDefault()
        e.stopPropagation()
        const form = $(this)
        let data = formToObject(this)
        data = {...data, ...globalParams.loginContext};
        // Collect numbers and do client validation
        let errors = []
        form.find('.has-error').removeClass('has-error')
        form.find('input.intl-phone-input').each(function () {
            const iti = window.intlTelInputGlobals.getInstance(this);
            if (iti.isValidNumber()) {
                data[$(this).attr('name')] = iti.getNumber()
            } else {
                errors.push($(this).data('error-message') || 'The phone number is invalid')
                $(this).closest('.form-group').addClass('has-error')
            }
        })
        addFormSummary(form, errors)
        if (errors.length) {
            return false
        }

        globalParams.lastSendCodeRequest = {
            url: form.attr('action'),
            type: form.attr('method'),
            contentType: false,
            dataType: 'json',
            data: data,
        }
        $.ajax(globalParams.lastSendCodeRequest).done(content => {
            pushHistory()
            modal.setContent(content, true).show()
        }).catch(error => {
            window.openAlert(error.responseJSON || getCommonError(), 'error')
            form.find('.form-group').addClass('has-error')
        })
        return false
    })

    modal.$.on('submit', 'form#VerifyCode', function (e) {
        e.preventDefault()
        e.stopPropagation()
        addAfterLoginActionParam();
        const form = $(this)
        let data = formToObject(this)
        data = {...data, ...globalParams.loginContext};
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            contentType: false,
            dataType: 'json',
            data: data,
        }).done(() => {
            // irrelevant
        }).catch((error) => {
            switch (error.status) {
                case 400:
                    window.openAlert(error.responseJSON, 'error')
                    form.find('.form-group-code').addClass('has-error')
                    window.openAlert(translate.errors.incorrect_code, 'error')
                    break
                case 401:
                    window.openAlert(translate.errors.too_many_attempts, 'error')
                    loadBack()
                    break
                case 410:
                    window.openAlert(translate.errors.invalid_session, 'error')
                    loadBack()
                    break
                case 302:
                    form.find('.form-group-code').removeClass('has-error')
                    break
                default:
                    window.openAlert(window.getCommonError(), 'error')
                    break
            }
        })
        return false
    })

    modal.$.on('click', '.send-again-button', function (e) {
        if (globalParams.lastSendCodeRequest) {
            $.ajax(globalParams.lastSendCodeRequest).done(content => {
                window.openAlert($(this.data('message') || 'New code was sent'), 'success')
            }).catch(error => {
                window.openAlert(error.responseJSON || window.getCommonError(), 'error')
            })
        }
        return false;
    })

// handles all password login windows and some opt as well, string search by form class name
    modal.$.on('submit', 'form.auth-ajax-form', function (e) {
        e.preventDefault()
        e.stopPropagation()
        addAfterLoginActionParam()
        let data = new FormData(this);
        data = {...data, ...globalParams.loginContext};
        const form = $(this)
        const options = {
            url: form.attr('action'),
            type: form.attr('method'),
            contentType: false,
            data: data,
        }
        if (options.type.toLowerCase() === 'post') {
            options.data = new FormData(this)
            options.processData = false
        } else {
            options.data = formToObject(this)
            options.dataType = 'json'
        }
        $.ajax(options).done((content) => {
            pushHistory()
            modal.setContent(content).show()
        }).catch((error) => {
            switch (error.status) {
                case 400:
                case 404:
                    window.openAlert(error.responseJSON || error.responseText || window.getCommonError(), 'error')
                    if (form.find('.form-group:visible').length === 1) {
                        form.find('.form-group:visible').addClass('has-error')
                    }
                    break
                case 302:
                    // console.debug('login success')
                    break
                default:
                    window.openAlert(window.getCommonError(), 'error')
            }
        })
        return false
    })

    modal.$.on('change', 'input#Checkbox__Agree_Terms', function (e) {
        const $body = $(this).closest('.window-body');
        let $inputGroup = $(this).closest('.form-input-group');

        if ($(this).is(':checked')) {
            $body.find('input.form-control').attr('disabled', false)
            $inputGroup.removeClass('has-error');
            $(this).removeAttr('aria-describedby');
            $(this).removeAttr('aria-invalid');
        }
    })

    modal.$.on('click', '.auth-button,.auth-button-small', function () {
        if (!agreeTerms()) {
            return false
        }
        addAfterLoginActionParam()
    })

    modal.$.on('click', '.terms-check', agreeTerms)
    return modal
}
